import { Component, Input, OnInit } from '@angular/core';
import { WellComponent } from '../well-configuration/models';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { StorageKeys, StoreService } from 'src/app/core/services/store.service';

@Component({
    selector: 'app-schematic-info',
    templateUrl: './schematic-info.component.html',
    styles: [``],
    standalone: false
})
export class SchematicInfoComponent implements OnInit {
  @Input()
  public tubular: WellComponent;
  public units: { long: string, short: string };

  constructor(private _store: StoreService) { }

  async ngOnInit(): Promise<void> {
    this.tubular = null;
    const currentUserUnits = await this._store.get<UserUnitsModel>(StorageKeys.UNITS);
    this.units = {
      long: currentUserUnits.longLengths,
      short: currentUserUnits.shortLengths
    };
  }

  public handleClose(): void {
    this.tubular = null;
  }

  get hasConnections(): boolean {
    return this.tubular?.stringSections?.some(t => t.connection?.name) ?? false;
  }

}
